import Link from "next/link";
import Image from 'next/image';
import {useRouter} from "next/navigation";
import {PanelMenu} from 'primereact/panelmenu';


export default function Sidebar({userRole}) {
    const router = useRouter();
    let items = []
    if (userRole === "TINTUC_ADMIN") {
        items = [
            {
                label: 'Quản lý bài viết',
                items: [
                    {
                        label: 'Danh sách bài viết',
                        url: '/con-rua-bien/admin/danh-sach-bai-viet'
                    },
                    {
                        label: 'Thêm bài viết mới',
                        url: '/con-rua-bien/admin/them-bai-viet'
                    }
                ]
            }
        ]
    } else {
        items = [
            {
                label: 'Quản lý bài viết',
                items: [
                    {
                        label: 'Danh sách bài viết',
                        url: '/con-rua-bien/admin/danh-sach-bai-viet'
                    },
                    ...(userRole === "SUPER_ADMIN" ? [
                        {
                            label: 'Thêm bài viết mới',
                            url: '/con-rua-bien/admin/them-bai-viet'
                        }
                    ] : [])
                ]
            },
            {
                label: 'Quản lý ảnh',
                items: [
                    {
                        label: 'Danh sách hình ảnh',
                        url: '/con-rua-bien/admin/danh-sach-hinh-anh'
                    },
                   
                    ...(userRole === "SUPER_ADMIN" ? [
                        {
                            label: 'Thêm hình ảnh',
                            url: '/con-rua-bien/admin/them-hinh-anh'
                        },
                        {
                            label: 'Quản lý ảnh banner',
                            url: '/con-rua-bien/admin/quan-ly-banner'
                        },
                        {
                            label: 'Thêm banner',
                            url: '/con-rua-bien/admin/them-banner'
                        },
                    ] : [])
                ]
            },
            {
                label: 'Quản lý tài khoản',
                items: [
                    {
                        label: 'Danh sách tài khoản',
                        url: '/con-rua-bien/admin/danh-sach-tai-khoan'
                    },
                    ...(userRole === "SUPER_ADMIN" ? [
                        {
                            label: 'Thêm tài khoản',
                            url: '/con-rua-bien/admin/them-tai-khoan'
                        }] : [])
                ]
            },
            {
                label: 'Quản lý bảng giá',
                items: [
                    {
                        label: 'Danh sách bảng giá',
                        url: '/con-rua-bien/admin/danh-sach-bang-gia'
                    },
                    ...(userRole === "SUPER_ADMIN" ? [
                        {
                            label: 'Thêm bảng giá',
                            url: '/con-rua-bien/admin/them-bang-gia'
                        }
                    ] : [])
                ]
            },
            {
                label: 'Quản lý chi nhánh',
                url: '/con-rua-bien/admin/quan-ly-chi-nhanh'
            },
            {
                label: 'Quản lý danh mục',
                url: '/con-rua-bien/admin/quan-ly-danh-muc'
            },
            {
                label: 'Quản lý liên hệ',
                url: '/con-rua-bien/admin/quan-ly-lien-he'
            },
            {
                label: 'Trang giới thiệu',
                url: '/con-rua-bien/admin/gioi-thieu'
            },
            {
                label: 'Trang liên hệ',
                url: '/con-rua-bien/admin/lien-he'
            },
        ]
    }
    return (
        <>
            {/*<SidebarScripts/>*/}
            <nav id="sidebar" className="sidebar-wrapper">
                <div className="sidebar-brand">
                    <Link href="/con-rua-bien/admin">
                        <Image src="/img/logo-ngang-trang.webp" alt="Web Admin Dashboard" width={230} height={80}/>
                    </Link>
                </div>
                <div
                    className="sidebar-content"
                    style={{overflow: "scroll", scrollbarWidth: "none"}}
                >
                    {/*-- Sidebar menu start -- */}
                    <div className="sidebar-menu">
                        <PanelMenu model={items} className="w-full md:w-20rem"/>
                    </div>
                    {/*-- Sidebar menu end -- */}
                </div>
            </nav>
        </>
    );
}

